import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import DateRangeManager from './daterange-manager';
import templateMarkup from 'raw-loader!./daterange-widget.html';
import Vue from 'vue';
import vuetify from '../../../plugins/vuetify';
import DateSelectionPopup from '../../../vueComponents/dateSelectionPopup/dateSelectionPopup.vue';
import DataProvider from "../../../app/data-framework/data-provider";

function DateRangeWidget(params) {
    this.initialize(params);
}

DateRangeWidget.prototype = {
    // This runs when the component is torn down. Put here any logic necessary to clean up,
    // for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
    dispose: function dispose() {
        this.dateRangeManager = null;
        _.forEach(this.subscriptions, function (subscription) {
            subscription.dispose();
        });
        if (dateRangePicker) {
            this.dateRangePicker.$destroy();
            this.dateRangePicker.$el.parentNode.removeChild(this.dateRangePicker.$el);
        }
    },

    initialize: function (params) {
        this.dateRange = params.dateRange;

        var dataRangeValue = this.dateRange();
        var rangeParams = (!_.isNil(dataRangeValue) && !_.isEmpty(dataRangeValue))
            ? {
                dateRange: {
                    startDate: dataRangeValue.startDate,
                    endDate: dataRangeValue.endDate
                }
            }
            : {};

        this.dateRangeManager = new DateRangeManager(_.extend({}, params, rangeParams));
        this.dateRange(this.dateRangeManager.getDateRange());
        this.formattedDateRange = ko.observable(this.dateRangeManager.getFormattedDateRange());
        this.timezoneText = _.get(this.dateRangeManager.getTimezone(), 'text', '');

        this.isReadOnly = _.get(params, 'readOnly', false);

        setupSubscriptions(this);

        //init date range picker
        let updateDateRange = this.updateDateRange.bind(this);
        let dateConfig = this.dateRangeManager.getConfiguration(DataProvider.getInstance().isInternalUser());
        this.dateRangePicker = new Vue({
          el: '#dateSelectionHook',
          vuetify,
          data: {
            dateText: ko.unwrap(this.formattedDateRange),
            minDate: dateConfig.minDate.toDate(),
            maxDate: dateConfig.maxDate.toDate(),
            isReadOnly: this.isReadOnly,
            value: ko.unwrap(this.dateRange),
            updateDateRange: updateDateRange,
          },
          render(h) {
            return h('span', { attrs: { id: 'dateSelectionHook' } }, [
              h(DateSelectionPopup, {
                props: {
                    dateText: this.dateText,
                    isReadOnly: this.isReadOnly,
                    minDate: this.minDate,
                    maxDate: this.maxDate,
                    value: this.value,
                },
                on: { 'range-selected': this.updateDateRange }
                })
            ]);
          }
        });
    },

    updateDateRange: function (range) {
        let start = moment(range.startDate);
        let end = moment(range.endDate);
        this.dateRangePicker.value = range;
        document.removeEventListener('click', this.outsideClickListener, true);
        this.dateRangeManager.updateDateRange(start, end);
        this.dateRange(this.dateRangeManager.getDateRange());
        this.updateFormattedDateRange();
    },

    updateFormattedDateRange: function () {
        this.formattedDateRange(this.dateRangeManager.getFormattedDateRange());
        if (this.dateRangePicker) {
          this.dateRangePicker.dateText = ko.unwrap(this.dateRangeManager.getFormattedDateRange());
        }
    },

    updateDateRangePickerDateRange: function (dateRange) {
        if (this.dateRangePicker) {
            this.dateRangePicker.vaulue = dateRange;
        }
    }
};

function setupSubscriptions(self) {
    self.subscriptions = [
        self.dateRange.subscribe(function (range) {
            self.dateRangePicker.value = range;
            self.dateRangeManager.updateDateRange(range.startDate, range.endDate);
            if (!self.isReadOnly) {
                self.updateDateRangePickerDateRange(range);
            }
            self.updateFormattedDateRange();
        })
    ];
}

export default { template: templateMarkup, viewModel: DateRangeWidget };
